var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoofCareNewEntry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hoof_care_new_entry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 0.97,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hoof_care_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300.45,
    cy: 299.97,
    r: 299.05,
    fill: "#ff7336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.31,244.69h-90V159.78a56,56,0,0,0-55.85-55.85h0a56,56,0,0,0-55.85,55.85v84.91H165.71a56,56,0,0,0-55.85,55.85h0a56,56,0,0,0,55.85,55.85h79.91v85a56,56,0,0,0,55.85,55.85h0a56,56,0,0,0,55.85-55.85v-85h90a56,56,0,0,0,55.85-55.85h0A56,56,0,0,0,447.31,244.69Z",
    fill: "#ffe5dc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoofCareNewEntry);
export default __webpack_public_path__ + "static/media/hoof_care_new_entry.ec24a4dd7e8bc660df69004d2f2f3305.svg";
export { ForwardRef as ReactComponent };